var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_227_680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#054fbd",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1357 31.1143C10.153 29.8818 9.38475 28.5073 8.831 26.9908C8.277 25.4745 8 23.8692 8 22.175C8 18.4712 9.22162 15.2765 11.6649 12.5907C14.1081 9.90525 17.1365 8.375 20.75 8V10.25C17.7595 10.6095 15.2619 11.9143 13.2571 14.1643C11.2524 16.4143 10.25 19.0845 10.25 22.175C10.25 23.575 10.4625 24.8938 10.8875 26.1313C11.3125 27.3688 11.925 28.5 12.725 29.525L11.1357 31.1143ZM22.25 36.425C20.5308 36.425 18.9044 36.1443 17.3709 35.5828C15.8371 35.0212 14.4539 34.2366 13.2211 33.2289L14.8018 31.625C15.8268 32.425 16.9681 33.05 18.2259 33.5C19.4836 33.95 20.825 34.175 22.25 34.175C23.675 34.175 25.0164 33.9476 26.2741 33.4929C27.5319 33.0381 28.678 32.4108 29.7125 31.6108L31.2931 33.2142C30.0606 34.222 28.6775 35.009 27.1437 35.5752C25.61 36.1417 23.9788 36.425 22.25 36.425ZM33.3789 31.1L31.775 29.4961C32.5655 28.4711 33.1756 27.3423 33.6054 26.1095C34.0351 24.877 34.25 23.5655 34.25 22.175C34.25 19.0845 33.25 16.4191 31.25 14.1789C29.25 11.9384 26.7596 10.6335 23.7789 10.2643V8.01463C27.3826 8.39913 30.4038 9.92937 32.8423 12.6054C35.2808 15.2814 36.5 18.4712 36.5 22.175C36.5 23.8692 36.2255 25.4721 35.6765 26.9836C35.1275 28.4951 34.3616 29.8673 33.3789 31.1ZM18.875 28.2328V16.1173L28.3078 22.175L18.875 28.2328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_227_680",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_227_680",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/videoPlayer.b45fd681b6e7f15d1f8c4313050b81ce.svg";
export { ForwardRef as ReactComponent };